import React, { Children } from 'react';

interface ButtonIconProps extends React.ComponentPropsWithRef<'div'> {
  children: React.ReactElement
}

/** <ButtonIcon/ > is made to be nested in <Button /> or <IconButton /> */
const ButtonIcon:React.FC<ButtonIconProps> = ((props: ButtonIconProps) => React.cloneElement(
  Children.toArray(props.children)[0] as React.ReactElement<any>,
  {
    'data-parent': 'button',
    size: 24
  },
));

ButtonIcon.displayName = 'ButtonIcon';

export { ButtonIcon as default, ButtonIconProps };